import { render, staticRenderFns } from "./FormAlert.vue?vue&type=template&id=2285e9af"
import script from "./FormAlert.vue?vue&type=script&lang=ts"
export * from "./FormAlert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports